<template>
    <div>
        <b-button v-if="showCreate" variant="primary" @click="goToCreate">
            <i class="far fa-plus fa-fw"></i
            ><span class="ml-1">Ajouter un commentaire</span>
        </b-button>
        <b-button variant="secondary" @click="goToClients">
            <i class="far fa-arrow-alt-left fa-fw"></i
            ><span class="ml-1"> Retour à la liste des tiers</span>
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'HistoryFooter',

    methods: {
        goToCreate() {
            this.$store.commit('browsing/SET_CREATING')
        },
        goToClients() {
            window.location = '/clients'
        },
    },

    computed: {
        ...mapState({
            activePage: (state) => state.browsing.pageName,
            creating: (state) => state.browsing.creating,
        }),

        showCreate() {
            return !this.creating
        },
    },
}
</script>

<style scoped></style>
